import Immutable from 'immutable';
const LOAD = 'docs/LOAD';
const LOAD_IMAGES = 'docs/LOAD_IMAGES';
const LOAD_SUCCESS = 'docs/LOAD_SUCCESS';
const LOAD_IMAGES_SUCCESS = 'docs/LOAD_IMAGES_SUCCESS';
const LOAD_FAIL = 'docs/LOAD_FAIL';
const LOAD_DOCS_LIST = 'docs/LOAD_DOCS_LIST';
const LOAD_DENTIST_DOCS_LIST = 'docs/LOAD_DENTIST_DOCS_LIST';
const LOAD_SAVE_FORM = 'docs/LOAD_SAVE_FORM';
const CLOSE_ERROR_MESSAGE = 'docs/CLOSE_ERROR_MESSAGE';
const SAVE_CONTRACT_MAPPINGS_REQUEST = 'docs/SAVE_CONTRACT_MAPPINGS_REQUEST';
const SAVE_CONTRACT_MAPPINGS_SUCCESS = 'docs/SAVE_CONTRACT_MAPPINGS_SUCCESS';
const SAVE_CONTRACT_MAPPINGS_FAILURE = 'docs/SAVE_CONTRACT_MAPPINGS_FAILURE';
const GET_CONTRACT_MAPPINGS_REQUEST = 'docs/GET_CONTRACT_MAPPINGS_REQUEST';
const GET_CONTRACT_MAPPINGS_SUCCESS = 'docs/GET_CONTRACT_MAPPINGS_SUCCESS';
const GET_CONTRACT_MAPPINGS_FAILURE = 'docs/GET_CONTRACT_MAPPINGS_FAILURE';

const initialState = Immutable.fromJS({
  isLoad: false,
  isLoadImages: false,
  loadErr: null,
  loading: false,
  docs: null,
  docsList:[],
  docsImages: {},
  dentistDocsList: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_IMAGES:
      return state
        .set('isLoadImages', action.res);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('docs', action.res);

    case LOAD_IMAGES_SUCCESS:
      return state
        .set('isLoadImages', false)
        .set('docsImages', action.res);

    case LOAD_DOCS_LIST:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('docsList', action.res);

    case LOAD_DENTIST_DOCS_LIST:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('dentistDocsList', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('schedule', null);

    case LOAD_SAVE_FORM:
      return state
        .set('isLoad', false)
        .set('loadErr', null);

    case SAVE_CONTRACT_MAPPINGS_REQUEST:
      return state.set('loading', true);

    case SAVE_CONTRACT_MAPPINGS_SUCCESS:
      return state
        .set('loading', false)
        .set('loadErr', null);

    case SAVE_CONTRACT_MAPPINGS_FAILURE:
      return state
        .set('loading', false)
        .set('loadErr', action.error);

    case GET_CONTRACT_MAPPINGS_REQUEST:
      return state.set('loading', true);

    case GET_CONTRACT_MAPPINGS_SUCCESS:
      return state
        .set('loading', false)
        .set('loadErr', null);

    case GET_CONTRACT_MAPPINGS_FAILURE:
      return state
        .set('loading', false)
        .set('loadErr', action.error);

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const saveForm = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.post(`/docs/saveDoc`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const saveDentist = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.post(`/docs/saveDentist`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const updateDoc = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/docs/updateDoc`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const updateDentistDoc = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/docs/updateDentistDoc`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const uploadBase64Image = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/udr/uploadBase64Image`, {data: obj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getDocsList = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/docs/getDocsList${ id ? `/${id}` : ''}`);
    !id && dispatch({ type: LOAD_DOCS_LIST, res: res });
    dispatch({ type: LOAD_SUCCESS });
    dispatch(getSignedUrl(res));
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getDocsByDentist = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let params = '';
  if(id) {
    params = `/${id}`;
  }
  try {
    let res = await api.get(`/docs/getDocsByDentist${params}`);
    dispatch({ type: LOAD_DOCS_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getDentistDocsList = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let params = '';
  if(id) {
    params = `/${id}`;
  }
  try {
    let res = await api.get(`/docs/getDentistDocsList${params}`);
    dispatch({ type: LOAD_DENTIST_DOCS_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getHistoryFiles = (getHistoryFiles) => async (dispatch, getState, api) => {
  let params = '';
  if(getHistoryFiles) {
    params = `/${JSON.stringify(getHistoryFiles)}`;
  }
  try {
    let res = await api.get(`/docs/getHistoryFiles${params}`);
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getSignedIconUrl = (key) => async (dispatch, getState, api) => {
  try {
    let signedUrl = await api.get(`/udr/s3/getImage/${key}`);
    return signedUrl;
  } catch (err) {
    return 'failed signedUrl';
  }
}
export const getSignedUrl = (data) => async (dispatch, getState, api) => {
  if(!data || !data.length)
    return false;

  let arrayString = []
  data.forEach( item => {
    (item.udaDentistDocuments || []).forEach(document => {
      if(document.fileLink && document.fileLink.length > 0)
        arrayString.push(document.fileLink);
    })

    if(item.icon) {
      arrayString.push(item.icon);
    }
    if(item.UdaDocuments && item.UdaDocuments.icon) {
      arrayString.push(item.icon);
    }
  });

  if(!arrayString.length)
    return false;

  dispatch({ type: LOAD_IMAGES, res: true });

  try {
    let res = await api.get(`/udr/s3/getImage?fileKeys=${arrayString.join(",")}`);
    let docsImages = {}
    if(res && Object.keys(res).length) {
      Object.keys(res).forEach( key => {
        docsImages[key] = res[key];
      });
    }
    dispatch({ type: LOAD_IMAGES_SUCCESS, res: docsImages });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_IMAGES, res: false });
  }
};

export const uploadFromGDrive = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_IMAGES, res: true });
  try {
    let res = await api.post(`/udr/s3/uploadGDrive`, {data});
    dispatch({ type: LOAD_IMAGES_SUCCESS, res: false });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_IMAGES, res: false });
  }
};

export const getComments = (params) => async (dispatch, getState, api) => {
  try {
    const query = Object.keys(params)
        .filter(key => params[key])
        .map(key => `${key}=${params[key]}`).join('&');
    return await api.get(`/docs/comments?${query}`);
  } catch (error) {
    return [];
  }
};

export const saveComment = (data) => async (dispatch, getState, api) => {
  try {
    return await api.post(`/docs/comment`, {data});
  } catch (err) {
    return err;
  }
};

export const getDoctorContract = (id) => async (dispatch, getState, api) => {
  try {
    let params = "";
    if (id || id>0) {
      params = `/${id}`;
    }
    return await api.get(`/contract/user${params}`);
  } catch (error) {
    return [];
  }
};

export const getDoctorContractAndAddendum = (id) => async (dispatch, getState, api) => {
  try {
    let params = "";
    if (id || id>0) {
      params = `/${id}`;
    }
    return await api.get(`/contract/addendums/user${params}`);
  } catch (error) {
    return [];
  }
};

export const getAllContractsForMultipleUsers = () => async (dispatch, getState, api) => {
  try {
    return await api.get(`/contract/multiple-users`);
  } catch (error) {
    return [];
  }
}


export const deleteDoctorContract = (id) => async (dispatch, getState, api) => {
  try {
    return await api.get(`/contract/delete/${id}`);
  } catch (error) {
    return [];
  }
};

export const saveDoctorContract = (data) => async (dispatch, getState, api) => {
  try {
    return await api.post(`/contract/save`, {data});
  } catch (err) {
    return err;
  }
};
export const getFileURL = (data) => async (dispatch, getState, api) => {
  try {
    return await api.get(`/udr/s3/getImage?fileKeys=${data}`);
  } catch (err) {
    return err;
  }
};

export const downloadFileURL = (data) => async (dispatch, getState, api) => {
  try {
    return await api.get(`/udr/s3/downloadImage?fileKeys=${data}`);
  } catch (err) {
    return err;
  }
};

export const saveContractMappings = (userId, mappings) => async (dispatch, getState, api) => {
  try {
    dispatch({ type: SAVE_CONTRACT_MAPPINGS_REQUEST });
    const response = await api.post('/udr/contract-mappings', {
      data: {
        userId,
        mappings
      }
    });
    dispatch({ type: SAVE_CONTRACT_MAPPINGS_SUCCESS, response });
    return response;
  } catch (error) {
    dispatch({ type: SAVE_CONTRACT_MAPPINGS_FAILURE, error });
    return error;
  }
};

export const getContractMappings = (userId) => async (dispatch, getState, api) => {
  try {
    let { data } = await api.get(`/udr/contract-mappings/${userId}`);
    return data;
  } catch (err) {
    return err;
  }
};
